module.exports = __webpack_public_path__ + "img/scavenger.c802630e.jpg";